import * as THREE from 'three';

export default class Skybox
{
    constructor(scene, topColor, bottomColor)
    {
        this.scene = scene;
        this.topColor = topColor;
        this.bottomColor = bottomColor;
    }

    setupShaderMaterial()
    {
        let uniforms = 
        {
            "uTopColor":     { value: this.topColor },
			"uBottomColor":  { value: this.bottomColor },
			"uOffset":       { value: 33 },
			"uExponent":     { value: 0.6 }
        };

        let skyMat = new THREE.ShaderMaterial( 
            {
				uniforms: uniforms,
                vertexShader: `
                varying vec3 vWorldPosition;

                void main() 
                {
                    vec4 worldPosition = modelMatrix * vec4(position, 1.0);
                    vWorldPosition = worldPosition.xyz;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                }
                `,
                fragmentShader: `
                uniform vec3 uTopColor;
                uniform vec3 uBottomColor;
                uniform float uOffset;
                uniform float uExponent;
                varying vec3 vWorldPosition;

                void main() 
                {
                    float h = normalize( vWorldPosition + uExponent ).y; //horisont
                    gl_FragColor = vec4( mix( uBottomColor, uTopColor, max( pow( max( h , 0.01), uExponent ), 0.0 ) ), 1.0 );
                }
                `,
				side: THREE.BackSide
            } );
        return skyMat;    
    };

    createSky()
    {
        let skyGeo = new THREE.SphereBufferGeometry(500, 32, 32);
		let skyMat = this.setupShaderMaterial();
		let sky = new THREE.Mesh(skyGeo, skyMat);
		this.scene.add(sky);
    };
}